import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  topSelectionCalloutProps: {
    description: 'x convience fee applied',
    state: 'lilac'
  },
  primaryCallout: {
    title: 'Title goes here',
    description: 'Descriptor goes here',
    showCrossDismissBtn: true,
    iconName: 'BillIcon',
    state: 'lilac'
  },
  secondaryCallout: {
    description: 'offer available on ICICI cards. you can choose to proceed without offer',
    showCrossDismissBtn: true,
    iconName: 'BillIcon',
    state: 'warning'
  },
  cardNumberInputProps: {
    placeholder: 'card number',
    maxLength: 23,
    keyboardType: 'numeric'
  },
  cardNameInputProps: {
    placeholder: 'name on card'
  },
  cardDateInputProps: {
    placeholder: 'valid thru (mm/yy)',
    maxLength: 5,
    keyboardType: 'numeric'
  },
  cardCVVInputProps: {
    placeholder: 'CVV',
    hintText: 'What is',
    hintActionText: 'CVV?',
    maxLength: 3,
    showAppend: true,
    appendItems: {
      prefixIcon: {
        iconName: 'HideButtonIcon',
        isActionable: true
      },
      isPressable: true
    }
  },
  buttonProps: {
    direction: 'column',
    leftCta: {
      title: 'Pay ₹2,299',
      version: 'variable-width',
      buttonType: 'primary'
    },
    rightCta: {
      title: 'Additional Tertiary Button',
      version: 'variable-width',
      buttonType: 'tertiary'
    }
  },
  isChecked: true,
  showTrustMarker: true,
  trustMarkerCtaTitle: 'KNOW MORE',
  trustMarkerTitle: 'Your card will be securely saved for faster payments. CVV number will not be saved.',
  trustMarkerCtaOnPressMetaData: {
    actions: [{}]
  },
  minCardNumberLength: 17
}, getTestId('PayCategoryCardWidgetContainer'));